export enum PersonalDetailsSteps {
  contactDetails = 'contact-details',
  existingClient = 'existing-client',
  remarks = 'remarks',
}
